export const MAX_TRANSACTIONS_PER_DISPUTE = 100;
